import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchNumbers } from "@/lib/api";

const NumberContext = createContext(null);

const STORAGE_KEY = "sv_selected_number"; // "all" | line id

export const NumberProvider = ({ children }) => {
  const { data: numbers = [], isLoading } = useQuery({ queryKey: ["numbers"], queryFn: fetchNumbers });
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem(STORAGE_KEY) || "all");

  useEffect(() => {
    if (!numbers.length) return;
    const exists = selectedId === "all" || numbers.some((n) => n.id === selectedId);
    if (!selectedId || !exists) {
      setSelectedId("all");
    }
  }, [numbers, selectedId]);

  useEffect(() => {
    if (selectedId) localStorage.setItem(STORAGE_KEY, selectedId);
  }, [selectedId]);

  const selectedNumber = useMemo(
    () => numbers.find((n) => n.id === selectedId) || null,
    [numbers, selectedId]
  );

  const value = { numbers, selectedId, setSelectedId, selectedNumber, isLoading };
  return <NumberContext.Provider value={value}>{children}</NumberContext.Provider>;
};

export const useNumbers = () => {
  const ctx = useContext(NumberContext);
  if (!ctx) throw new Error("useNumbers must be used within NumberProvider");
  return ctx;
};
